import { useEffect, useState } from 'react';

export const padCountdownUnit = (value: number) =>
  String(value).padStart(2, '0');

const emptyRemaining = { hours: 0, minutes: 0, seconds: 0 };

export const useRevealCountdown = (endsAt?: string) => {
  const [remaining, setRemaining] = useState(emptyRemaining);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!endsAt) {
      setReady(false);
      setRemaining(emptyRemaining);
      return undefined;
    }

    const tick = () => {
      const diff = Math.max(0, new Date(endsAt).getTime() - Date.now());
      const hours = Math.floor(diff / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);
      setRemaining({ hours, minutes, seconds });
    };

    tick();
    setReady(true);
    const id = window.setInterval(tick, 1000);
    return () => {
      window.clearInterval(id);
      setReady(false);
    };
  }, [endsAt]);

  return ready ? remaining : null;
};
